<template>
    <div class="detail">
        <div><label class="label">版本号</label><span class="highlight">{{info.version}}</span></div>
        <div><label class="label">发布渠道</label><span>{{info.channelInfo}}</span></div>
        <div><label class="label">发布者</label><span>{{info.nickName}}</span></div>
        <div v-if="type === 'product'"><label class="label">发布时间</label><span>{{formatDate(info.publishTime)}}</span></div>
        <div><label class="label">描述</label><span class="desc">{{info.description}}</span></div>
        <div class="cats"><label class="label">服务类目</label><div class="cat-container"><span class="cat" v-for="(item, index) in catList" :key="index">{{item}}</span></div></div>
        <div><label class="label">提交审核时间</label><span>{{formatDate(info.submitTime)}}</span></div>
        <div><label class="label">提交代码时间</label><span>{{formatDate(info.ctime)}}</span></div>
        <div><label class="label">二维码预览</label><img :src="url" width="260"></div>
    </div>
</template>
<script>
import QRCode from 'qrcode';
import formatDate from '@/lib/formatDate';
import dao from '@/lib/dao';

export default {
    props: {
        info: {
            type: Object,
            default() {
                return {};
            }
        },
        type: {
            type: String,
            default: ''
        },
        appInfo: {
            type: Object,
            default() {
                return {};
            }
        },
    },
    data() {
        return {
            appId: '',
            catList: [],
            url: ''
        };
    },
    watch: {
        type() {
            this.showQRcode();
        }
    },
    methods: {
        formatDate(str) {
            return formatDate(new Date(str), 'yyyy-MM-dd HH:mm');
        },
        getCates() {
            dao.shop.getCats({ appId: this.appId })
                .then(data => this.catList = data && data.catTrees || [])
                .catch(msg => this.$message.error(msg));
        },
        showQRcode() {
            const type = this.appInfo.type == 1 ? 'game' : 'applet';
            let link = '';
            switch(this.type) {
                case 'check': 
                    // 审核版本
                    link = `https://miniapp.bilibili.com/${type}/precheck-${this.info.appId}?_biliFrom=testdev`;
                    break;
                case 'gray':
                case 'product':
                    // 线上版本
                    link = `https://miniapp.bilibili.com/${type}/${this.info.appId}?_biliFrom=testdev`;
                    break;
                case 'timerProduct':
                    // 定时发布版本
                    link = `https://miniapp.bilibili.com/${type}/precheck-${this.info.appId}?storageId=${this.info.storageId}&_biliFrom=testdev`
            }
          
            QRCode.toDataURL(link)
                .then(url => {
                    this.url = url;
                })
                .catch(err => {
                    console.error(err);
                });
        }
    },
    mounted() {
        this.appId = this.$route.params.appId;
        this.getCates();
        this.showQRcode();
    }
}
</script>
<style lang="less" scoped>
.detail {
    padding: 5px 5px 0px;
    color: #5C667E;
    > div {
        margin-bottom: 12px;
        padding-left: 87px;
        position: relative;
        min-height: 17px;
        line-height: 17px;
        .label {
            position: absolute;
            left: 0;
            display: inline-block;
            width: 77px;
            text-align: right;
        }
        .highlight {
            font-family: PingFangSC-Medium;
            font-size: 14px;
            color: #5C667E;
        }
        .desc {
            word-break: break-all;
        }
        &.cats {
            margin-bottom: 5px;
            .cat-container {
                display: inline-block;
                min-height: 12px;
                margin-right: -7px;
                &:empty {
                    margin-bottom: 7px;
                }
                .cat {
                    display: inline-block;
                    background-color: #EFF4FC;
                    border-radius: 2px;
                    padding: 2px 4px;
                    margin-right: 7px;
                    margin-bottom: 7px;
                }
            }
        }
    }
}
</style>





// WEBPACK FOOTER //
// src/components/DevBasicDetailPopper.vue